<template>
    <div id="slotwarnings-wrapper">
        <!-- >>> The Card/Button -->
        <v-card
            id="slotwarnings"
            class="py-2 px-4"
            color="rgba(0, 0, 0, .3)"
            dark
            flat
            link
            min-width="100"
            style="border-radius: 8px;position: relative;">
            <v-icon :large="$isDesktop()">
                mdi-alert
            </v-icon>
            <div v-if="slotWarnings.length > 0" class="notification">
                {{ slotWarnings.length }}
            </div>
        </v-card>
        <!-- <<< The Card/Button -->


        <!-- >>> The SlotWarnings Menu -->
        <v-menu
            v-model="menu"
            :close-on-content-click="false"
            :close-on-click="false"
            activator="#slotwarnings"
            bottom
            content-class="v-explanation"
            left
            nudge-left="8"
            offset-x origin="bottom right"
            transition="scale-transition"
            class="warningsMenu"
            max-height="750px"
            min-height="80%"
            :allow-overflow="false"
            style="overflow:hidden !important">
            <div style="width:850px;max-height: 800px;overflow:hidden;background: white;">
                <div class="pb-2">
                    <v-card-title class="justify-space-between align-baseline">
                        <div class="headline pl-7 mb-3 mt-8 justify-space-between align-baseline">
                            <div>Slot Warnings</div>
                            <div class="subtitle-1">
                                {{ get_flights_StartDate ? get_flights_StartDate.format('DD.MM.YY') : '' }}{{ get_flights_EndDate ? (get_flights_EndDate.format('DD.MM.YY') !== get_flights_StartDate.format('DD.MM.YY') ? ` - ${get_flights_EndDate.format('DD.MM.YY')}` : '') : '' }}
                            </div>
                            <div v-if="slotWarnings.length > 0" class="body-1">
                                {{ slotWarnings.length }} Slot issue{{ slotWarnings.length > 1 ? 's' : '' }} found
                            </div>
                        </div>
                        <a
                            class="d-flex pr-7"
                            @click="onClick_goToSlotmanager(get_flights_StartDate, get_flights_EndDate)">
                            <div>Slotmanagement</div>
                            <v-icon class="pl-2" color="primary">mdi-export</v-icon>
                        </a>
                    </v-card-title>
                </div>
                <v-card-text class="pa-5" style="background-color: white;max-height:570px;min-height:570px;overflow:scroll;">
                    <v-data-table
                        v-model="selectedChain"
                        :headers="headersChain"
                        :items="rotationAndChain_slotWarnings"
                        hide-default-footer
                        :disable-pagination="true"
                        :items-per-page="-1"
                        show-expand
                        :expanded.sync="expandedChain"
                        single-expand
                        :show-select="false"
                        fixed-header
                        height="100%"
                        class="slotWarningsTable"
                        style="border: 1px solid rgb(222, 222, 222)">
                            <!-- >>> OpeningHours:Column -->
                            <template v-slot:item="{ item, expand, isExpanded }">
                                <tr style="height:85px" :style="{ backgroundColor: isExpanded ? '#ab3b7b1b' : '' }">
                                    <td><span>{{ item.items.length }}</span></td>
                                    <td><span>{{ item.dateRange }}</span></td>
                                    <td><span>{{ $dayjsLocalToUTC(item.slotTime, 'vt') }}</span></td>
                                    <td>
                                        <div>{{ item.aircraftType.code }}</div>
                                        <a>{{ item.changedAircraft }}</a>
                                    </td>
                                    <td>
                                        <div style="display: grid;grid-template-rows: auto auto;" :style="{gridTemplateColumns: item.flightNo[1] ? 'auto auto auto' : 'auto' }">
                                            <div>
                                                {{ item.flightNo[0] }}</div>
                                            <div v-if="item.flightNo[1]">
                                                /
                                            </div>
                                            <div v-if="item.flightNo[1]">
                                                {{ item.flightNo[1] }}
                                            </div>
                                            <a>
                                                {{ item.changedFlightNo[0] }}
                                            </a>
                                            <div v-if="item.changedFlightNo[1]">
                                                /
                                            </div>
                                            <a>
                                                {{ item.changedFlightNo[1] }}
                                            </a>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="font-weight-bold">
                                            {{ item.airportSlot.aptCode }}
                                        </div>
                                    </td>
                                    <td>
                                        <div style="display: grid;grid-template-rows: auto auto;grid-template-columns: auto auto">
                                            <div>{{ item.slot[0] }}</div>
                                            <div>{{ item.slot[1] }}</div>
                                            <a>{{ item.changedSlot[0] }}</a>
                                            <a>{{ item.changedSlot[1] }}</a>
                                        </div>
                                    </td>
                                    <td>
                                        <v-chip>{{ item.status }}</v-chip>
                                    </td>
                                    <td>
                                        <v-icon
                                            v-if="item.items.length > 1"
                                            class="pointer"
                                            @click="expand(!isExpanded)">
                                            {{ isExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
                                        </v-icon>
                                    </td>
                                </tr>
                            </template>
                            <!-- >>> Expanded:Column -->
                            <template v-slot:expanded-item="{ headers, item }">
                                <td
                                    :colspan="headersRotation.length + 2"
                                    style="padding:0 0 44px 0 !important;background-color:#f4e1e1;">
                                    <div style="margin-left:22px;height:44px;">
                                        <h2 style="margin-left: 22px;height:100%;display:flex;align-items:center;">
                                            Rotation / Leg
                                        </h2>
                                    </div>
                                    <div style="display:flex;">
                                        <div style="width:44px;" />
                                        <v-data-table
                                            v-model="selectedRotation"
                                            :headers="headersRotation"
                                            :items="item.items"
                                            hide-default-footer
                                            :disable-pagination="true"
                                            :items-per-page="-1"
                                            style="width:calc(100% - 44px);height:100%;">
                                                <!-- >>> OpeningHours:Column -->
                                                <template v-slot:item="{ item, expand, isExpanded }">
                                                    <tr style="height:85px" @click="onClick_rowClicked(item)">
                                                        <td>
                                                            <span>{{ $dayjsLocalToUTC(item.slotTime, 'DD.MM.YYYY') }}</span>
                                                        </td>
                                                        <td><span>{{ $dayjsLocalToUTC(item.slotTime, 'vt') }}</span></td>
                                                        <td>
                                                            <div>{{ item.aircraftType.code }}</div>
                                                            <a>{{ item.changedAircraft }}</a>
                                                        </td>
                                                        <td>
                                                            <div style="display: grid;grid-template-rows: auto auto;" :style="{gridTemplateColumns: item.flightNo[1] ? 'auto auto auto' : 'auto' }">
                                                                <div>
                                                                    {{ item.flightNo[0] }}</div>
                                                                <div v-if="item.flightNo[1]">
                                                                    /
                                                                </div>
                                                                <div v-if="item.flightNo[1]">
                                                                    {{ item.flightNo[1] }}
                                                                </div>
                                                                <a>
                                                                    {{ item.changedFlightNo[0] }}
                                                                </a>
                                                                <div v-if="item.changedFlightNo[1]">
                                                                    /
                                                                </div>
                                                                <a>
                                                                    {{ item.changedFlightNo[1] }}
                                                                </a>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div class="font-weight-bold">
                                                                {{ item.airportSlot.aptCode }}
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div style="display: grid;grid-template-rows: auto auto;grid-template-columns: auto auto">
                                                                <div>{{ item.slot[0] }}</div>
                                                                <div>{{ item.slot[1] }}</div>
                                                                <a>{{ item.changedSlot[0] }}</a>
                                                                <a>{{ item.changedSlot[1] }}</a>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <v-chip>{{ item.status }}</v-chip>
                                                        </td>
                                                    </tr>
                                                </template>
                                        </v-data-table>
                                    </div>
                                </td>
                            </template>
                            <!-- <<< Expanded:Column -->
                    </v-data-table>
                </v-card-text>
                <!-- <a class="mt-2">
                    *changed to
                </a> -->
            </div>
        </v-menu>
    </div>
    <!-- <<< The SlotWarnings Menu -->
</template>

<script>
    import router from '../../router';
    import { mapGetters } from 'vuex';


    export default {
        name: 'SlotWarnings',

        /* >>> *************************************************************** / /* Props */
        props: {

            startDate: Object,
            endDate: Object

        }, // eo props{}
        /* <<< ****************************************************************/


        /* >>> *************************************************************** / /* Data */
        data: () => ({

            menu: false,
            expandedChain: [],
            selectedChain: [],
            selectedRotation: [],

            // >>> ------------------------------------ Tables Headers
				headersChain: [
					{ text: 'Chain', value: '', class: 'sticky-header grey lighten-3', sortable: false },
					{ text: 'Date', value: 'slotTime', class: 'sticky-header grey lighten-3', sortable: true },
					{ text: 'DOW', value: 'slotTime', class: 'sticky-header grey lighten-3', sortable: false },
					{ text: 'A/C', value: 'aircraftType', class: 'sticky-header grey lighten-3', sortable: false },
					{ text: 'Flight No.', value: 'flightNo', class: 'sticky-header grey lighten-3', sortable: false },
					{ text: 'Airport', value: 'airportSlot.aptCode', class: 'sticky-header grey lighten-3', sortable: true },
					{ text: 'Slot', value: 'slot', class: 'sticky-header grey lighten-3', sortable: false },
					{ text: 'Status', value: 'status', class: 'sticky-header grey lighten-3', sortable: true },
					{ text: '', value: 'data-table-expand', class: 'sticky-header grey lighten-3', sortable: false }
				],
				headersRotation: [
					{ text: 'Date', value: 'slotTime', class: 'sticky-header grey lighten-3', sortable: true },
					{ text: 'DOW', value: 'slotTime', class: 'sticky-header grey lighten-3', sortable: false },
					{ text: 'A/C', value: 'aircraftType', class: 'sticky-header grey lighten-3', sortable: false },
					{ text: 'Flight No.', value: 'flightNo', class: 'sticky-header grey lighten-3', sortable: false },
					{ text: 'Airport', value: 'airportSlot.aptCode', class: 'sticky-header grey lighten-3', sortable: true },
					{ text: 'Slot', value: 'slot', class: 'sticky-header grey lighten-3', sortable: false },
					{ text: 'Status', value: 'status', class: 'sticky-header grey lighten-3', sortable: true }
				]

        }), // eof data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'get_flights_slotWarnings',
                'get_flights_rotationAndChain_slotWarnings',
                'get_flights_StartDate',
                'get_flights_EndDate',
                'get_AircraftConfigs'
            ]),

            /*******************************************************************
            * slotWarnings{}
            *
            * Desc:
            * Note:
            *
            */
            slotWarnings: {
                get() {
                    return this.get_flights_slotWarnings;
                },
                set(val) {
                    return val;
                }
            }, // eof slotWarnings{}

            /*******************************************************************
            * slotWarnings{}
            *
            * Desc:
            * Note:
            *
            */
            rotationAndChain_slotWarnings: {
                get() {
                    return this.get_flights_rotationAndChain_slotWarnings;
                },
                set(val) {
                    return val;
                }
            } // eof rotationAndChain_slotWarnings{}

        },
        /* <<< ****************************************************************/


        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc:
        * Note:
        *
        */
		created: function() {

            const me = this;


            me.$toc('>>> components/core/SlotWarnings.vue >>> created');
            // me.expandedChain = me.rotationAndChain_slotWarnings;

		}, // eo function created()
		/* <<< ****************************************************************/

        mounted: function () {

            const me = this;

            me.$toc('>>> components/core/SlotWarnings.vue >>> created');
            //me.expandedChain = [];
        },


        /***********************************************************************
        * Lifecyclehook::destroyed
        *
        * Desc:
        * Note:
        *
        */
		destroyed: function() {

            const me = this;


            me.$toc('>>> components/core/SlotWarnings.vue >>> destroyed');

		}, // eo function destoryed()
		/* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

            // ...mapActions([]),

            /***********************************************************************
            * onClick_goToSlotmanager
            *
            * Desc: Navigates with the date range parameters of the flights-scheduler
            * Desc: to the slotmanager
            * Note:
            *
            */
            onClick_goToSlotmanager: (startDate, endDate) => {

                const me = this;


                // me.$toc('>>> components/core/SlotWarnings.vue >>> onClick_goToSlotmanager');
                router.push({ name: 'Slotmanagement', params: { flights_dateRange: [startDate, endDate] } });

            } // eof onClick_goToSlotmanager

        } // eof methods()
        /* <<< ****************************************************************/

    };
</script>

<style lang="sass">
.v-SlotWarnings
    .v-item-group > *
        cursor: pointer

    &__item
        border-width: 3px
        border-style: solid
        border-color: transparent !important

    &--active
        border-color: #00cae3 !important
.sdr-chip--active
    background: #AB3B7A
    .v-chip__content
        color: #FFFFFF
.sdr-custom-text-input
    input
        text-transform: uppercase
</style>

<style scoped>
    .slotWarningsTable >>> tbody tr:hover {
        background-color: #ab3b7b1b !important;
     }
    .v-menu__content {
        max-height: 90% !important;
        overflow: hidden;
    }

    .v-data-table /deep/ .sticky-header {
        position: sticky;
        top: 0px;
        z-index: 1;
	}
</style>

<style>
    .notification {
        position:absolute;
        left:-7px;
        top:-7px;
        width:24px;
        height:24px;
        background-color:rgb(171, 43, 122);
        border-radius: 90px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-bottom-left-radius: 90px !important;
        border-bottom-right-radius: 90px !important;
    }
</style>

